import React from 'react';
import doller from "../../assests/MenuServies/doller.svg";
import db from "../../assests/MenuServies/db.svg";
import Automatic from "../../assests/MenuServies/Automatc.svg";
import workflow from "../../assests/MenuServies/workflow.svg";

import 'bootstrap/dist/css/bootstrap.min.css';
import './PerformanceEfficiency.css';

const cardData = [
  {
    id: 1,
    icon: doller,
    bgColor: 'card-green',
    text: 'Detect and eliminate idle workloads draining your budget.',
  },
  {
    id: 2,
    icon: db,
    bgColor: 'card-purple',
    text: 'Boost application speed, scalability, and uptime while ensuring reliability and seamless user experiences.',
  },
  {
    id: 3,
    icon: Automatic,
    bgColor: 'card-orange',
    text: 'Automate monitoring, analysis, and reporting to save IT teams 25+ hours monthly.',
  },
  {
    id: 4,
    icon: workflow,
    bgColor: 'card-blue',
    text: 'Drive operational excellence with minimal disruption to existing workflows.',
  },
];

const PerformanceEfficiency: React.FC = () => {
  return (
    <div style={{display:"flex",justifyContent:"center"}}>
    <div className=" py-5 performance-container">
      <h2 className="text-center performance-h2 mb-2">Performance & Efficiency at Scale</h2>
      <p className="text-center performance-p mb-4">Save money | Boost productivity | Scale with confidence.</p>

      <div className="row g-5 justify-content-center performance-row">
        {cardData.map(({ id, icon, bgColor, text }) => (
          <div key={id} className="col-12 col-sm-6 col-md-6 col-lg-4 custom-col-perform">
            <div className={`card h-100 p-3 ${bgColor}`}>
              
                <img src={icon} alt="icon" className="icon" />
             
              <p className="card-text">{text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default PerformanceEfficiency;
